/**
 * Copy to Clipboard
 * -----------------------------------------------------------------------------
 */

/**
 * Copy text/selection to system clipboard.
 *
 * This implementation may not work for all browsers, this API is new and
 * evolving.
 *
 * @param {String}   clip    What to copy to clipboard.
 * @param {Function} success What to do when copy is successful.
 * @param {Function} fail    What to do when copy fails.
 */
function copyToClipboard( clip, success, fail ) {

  navigator.permissions
    .query( { name: 'clipboard-write' } )
    .then( ( res ) => {

      if ( -1 !== [ 'granted', 'prompt' ].indexOf( res.state ) ) {

        navigator.clipboard
          .writeText( clip )
          .then( success, fail );

      }

    } );

}



module.exports = copyToClipboard;
